const Types = {
    SHOWBLOG: 'SHOWBLOG',
}


export default Types;